export default "__VITE_ASSET__b451c018__"